
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
  import PickerDate from '@/components/picker-date.vue';
  import Dialog from '@/components/dialog.vue';
  import delClass from './delClass.vue'
  import creatSecond from './creatSecond.vue'
  import creatThird from './creatThird.vue'
  import {
    productproductSecondClassList,
  } from "@/api/order"
  @Component({  
    name: '',
    components: {
      PageFooter,
      PickerDate,
      'slz-dialog': Dialog,
      delClass,
      creatSecond,
      creatThird
    }
  })
  export default class ProductList extends Vue {
    private keywords = ''
    private tablelist:any = []
    private tableloading = false
    private pageNo = 1
    private pageSize = 20
    private total = 0
    private rowmsg:any = {}
    private delShow = false
    private creatShow = false
    private creatThirdShow = false




    private mounted () {
      this.gettablelist()
    }



    private lookNext(row){
      this.$router.push({
        path:'thirdClass',
        query:{
          Id:row.Id,
          Name:row.SecondClassName,
        }
      })
    }
    private creatNext(row){
      this.rowmsg = {
        Id:0,
        ClassName:'',
        Level:3,
        SecondClassName:row.SecondClassName,
        ParentId:row.Id
      }
      this.creatThirdShow = true
    }

    editClass(row){
      this.rowmsg = {
        Id:row.Id||0,
        ClassName:row.SecondClassName||'',
        Level:2,
        FirstClassName:row.FirstClassName||decodeURI(this.$route.query.Name as string),
        ParentId:this.$route.query.Id
      }
      this.creatShow = true
    }
    private toDel(row){
      this.rowmsg = row
      this.delShow = true
    }
    private clearSearch(){
      this.keywords = ''
      this.doSearch()
    }
    private doSearch(){
      this.pageNo = 1
      this.gettablelist()
    }
    private changePage(e){
      this.pageNo = e
      this.gettablelist()
    }
    private async gettablelist(){
      try{
        this.tableloading = true
        let res:any = await productproductSecondClassList({
          ParentId:this.$route.query.Id,
          Keywords:this.keywords,
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize
        })
        if(res.IsSuccess){
          this.tablelist = res.Result.Results
          this.total = res.Result.Total
        }
      }finally{
        this.tableloading = false
      }
    }
  }
